<template>
    <div v-if="navigationData.length > 0" class="drawer-navigation">
        <div class="container">
            <div class="drawer-navigation__control-wrapper">
                <button :class="['burger-button',{'burger-button--open': drawerOpen}]" @click.prevent="toggleDrawer()" title="Open Navigation" type="button" >
                    <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32">
                        <path d="M140.001-254.616v-59.999h679.998v59.999H140.001Zm0-195.385v-59.998h679.998v59.998H140.001Zm0-195.384v-59.999h679.998v59.999H140.001Z"/>
                    </svg>
                </button>
            </div>
        </div>
        <div class="off-canvas">
            <div :class="['off-canvas__drawer',{'off-canvas__drawer--open': drawerOpen}]">
                <div class="container">
                    <div class="mobile-nav">
                        <div class="mobile-nav__header">
                            <button :class="['burger-button',{'burger-button--open': drawerOpen}]" @click.prevent="toggleDrawer()" title="Close Navigation" type="button" >
                                <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32">
                                    <path d="M256-213.847 213.847-256l224-224-224-224L256-746.153l224 224 224-224L746.153-704l-224 224 224 224L704-213.847l-224-224-224 224Z"/>
                                </svg>
                            </button>
                        </div>
                        <ul class="mobile-nav__items">
                            <li v-for="item of navigationData" :key="item.id" class="mobile-nav__item">
                                <div class="mobile-nav__control">
                                    <a class="mobile-nav__link" :href="item.url" :target="item.target">
                                        {{ item.name }}
                                    </a>
                                    <button
                                        v-if="hasSubNav(item)"
                                        :class="['mobile-nav__toggle', { 'mobile-nav__toggle--rotated': openSubMenus.has(item.id + 1) }]"
                                        :aria-expanded="openSubMenus.has(item.id + 1)"
                                        :aria-label="openSubMenus.has(item.id + 1) ? 'Collapse submenu' : 'Expand submenu'"
                                        @click="toggleSubMenu(item.id + 1)"
                                    >
                                        <span class="sr-only">{{ openSubMenus.has(item.id + 1) ? 'Collapse submenu' : 'Expand submenu' }}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                                            <path d="M480-371.923 267.692-584.231 296-612.539l184 184 184-184 28.308 28.308L480-371.923Z"/>
                                        </svg>
                                    </button>
                                </div>
                                <template v-if="hasSubNav(item)">
                                    <div :class="['mobile-nav__submenu',{'mobile-nav__submenu--open': selectedSubMenus.find(menuId => menuId === item.id + 1 )}]">
                                        <ul v-for="(subNav, index) in item.subNavigation" :key="index" class="mobile-nav__sub-items">
                                            <li v-if="subNav.title" class="mobile-nav__sub-label">
                                                <a v-if="subNav.feature" :href="subNav.feature.url" :target="subNav.feature.target">
                                                    {{ subNav.title }}
                                                </a>
                                                <template v-else>
                                                    {{ subNav.title }}
                                                </template>
                                            </li>
                                            <li v-for="subItem of subNav.items" class="mobile-nav__sub-item" :key="subItem.id">
                                                <a class="mobile-nav__sub-link" :href="subItem.url" :target="subItem.target">
                                                    {{ subItem.name }}
                                                </a>
                                            </li>
                                            <li v-if="subNav.feature" class="mobile-nav__sub-item mobile-nav__sub-item--feature">
                                                <a class="mobile-nav__sub-link" :href="subNav.feature.url" :target="subNav.feature.target">
                                                    <span>{{ subNav.feature.name }}</span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
                                                        <path d="M262.771-210.001 460.719-480 262.771-749.999h61.742L522.461-480 324.513-210.001h-61.742Zm241.692 0L702.411-480 504.463-749.999h61.742L764.153-480 566.205-210.001h-61.742Z"/>
                                                    </svg>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </template>
                            </li>
                            <template v-if="$slots.mobilecontrols">
                                <slot name="mobilecontrols"></slot>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'drawer-navigation',
    data() {
        return {
            drawerOpen: false,
            drawerReady: false,
            selectedSubMenus: [],
            subNavigation: []
        };
    },
    props: {
        navigationData: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    computed: {
        openSubMenus() {
            return new Set(this.selectedSubMenus);
        }
    },
    methods: {
        hasSubNav(item) {
            return item.subNavigation && item.subNavigation.length > 0;
        },
        toggleDrawer() {
            this.drawerReady = !this.drawerReady;
            setTimeout(() => {  
                this.drawerOpen = !this.drawerOpen;
            }, 100);
        },
        toggleSubMenu(id) {
            if(this.selectedSubMenus.includes(id)) {
                this.selectedSubMenus = this.selectedSubMenus.filter(menuId => menuId !== id);
            } else {
                this.selectedSubMenus.push(id);
            }
        },
    }
}
</script>